import React from "react"

export default function ConflictResolved() {
  return (
    <symbol id="conflict-resolved" viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.076 8.823l-3.9-3.922a.606.606 0 0 1 0-.854l.848-.853a.598.598 0 0 1 .849 0L4.5 5.836l5.627-5.66a.598.598 0 0 1 .849 0l.848.854a.606.606 0 0 1 0 .854l-6.9 6.94a.598.598 0 0 1-.848 0z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </symbol>
  )
}
